import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=54c1fb68&scoped=true&"
import script from "./Monitor.vue?vue&type=script&lang=js&"
export * from "./Monitor.vue?vue&type=script&lang=js&"
import style0 from "./Monitor.vue?vue&type=style&index=0&id=54c1fb68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1fb68",
  null
  
)

export default component.exports